import { useNavigate } from '@tanstack/react-router'

import TabBar from '@/components/ui/TabBar'

const TABS = [
  { value: 'updates', label: 'Updates' },
  { value: 'news', label: 'News' },
] as const

/**
 * Market update's page tabs (mock `.nw-pagetabs`): Updates | News, each its own route. News is
 * in neither the sidebar nor the section strip; this control and the rail's "More" reach it.
 *
 * `status` is the News list's quiet line ("Getting the latest stories"), on the right of the
 * row. The mock lets it push the tabs to the right edge while it shows; here the tabs stay put.
 */
export default function NewsPageTabs({
  value,
  status,
}: {
  value: (typeof TABS)[number]['value']
  status?: string | undefined
}) {
  const navigate = useNavigate()

  return (
    <div className="flex items-center justify-between gap-4">
      <TabBar
        ariaLabel="Market update"
        options={TABS}
        value={value}
        onChange={(next) => {
          void navigate({ to: next === 'news' ? '/market/news' : '/market/update' })
        }}
      />
      {status === undefined ? null : (
        <p role="status" className="text-body-xs whitespace-nowrap text-muted-foreground-subtle">
          {status}
        </p>
      )}
    </div>
  )
}
